import { KnowledgeBaseEntityResponse } from 'api/queries/knowledgeBase/types'
import { MIN_MARK_WEIGHT } from 'constants/knowledgeBaseContent'
import { KnowledgeBaseContentFormFields } from 'components/forms/KnowledgeBaseContentForm/KnowledgeBaseContentForm'
import { parseContentFields } from 'components/forms/KnowledgeBaseContentForm/utils'
import { EditKnowledgeBaseObjectVariables } from 'api/mutations/knowledgeBase/types'
import { KnowledgeBaseContentType } from 'types/KnowledgeBaseContentType'
import { metadataRecordToMetadataEntries } from 'screens/KnowledgeBase/utils'

const getFormInitValues = (
  data?: KnowledgeBaseEntityResponse
): KnowledgeBaseContentFormFields | undefined => {
  if (data) {
    const { dataType } = data
    if (dataType === KnowledgeBaseContentType.PRESENTATION) {
      return {
        type: KnowledgeBaseContentType.PRESENTATION,
        name: data.name,
        nameTranslations: data.nameTranslations,
        description: data.description,
        descriptionTranslations: data.descriptionTranslations || [],
        destination: data.parent?.id || null,
        knowledgeBaseFilesIds: data.knowledgeBaseFiles?.map((file) => file.id) || [],
        image: data.image?.miniaturePath || null,
        visibility: data.visibility,
        duration: data.duration ? data.duration / 60 : 0,
        labelIds: data.labels?.map(({ id }) => id) || [],
        subForm: {
          difficulty: data.difficulty,
          metadata: metadataRecordToMetadataEntries(data.metadata),
        }
      }
    }
    if (dataType === KnowledgeBaseContentType.TEST) {
      return {
        type: KnowledgeBaseContentType.TEST,
        name: data.name,
        nameTranslations: data.nameTranslations,
        description: data.description,
        descriptionTranslations: data.descriptionTranslations || [],
        destination: data.parent?.id || null,
        knowledgeBaseFilesIds: data.knowledgeBaseFiles?.map((file) => file.id) || [],
        image: data.image?.miniaturePath || null,
        visibility: data.visibility,
        duration: data.duration ? data.duration / 60 : 0,
        labelIds: data.labels?.map(({ id }) => id) || [],
        subForm: {
          difficulty: data.difficulty,
          metadata: metadataRecordToMetadataEntries(data.metadata),
        }
      }
    }
    if (dataType === KnowledgeBaseContentType.SANDBOX_TEST) {
      return {
        type: KnowledgeBaseContentType.SANDBOX_TEST,
        name: data.name,
        nameTranslations: data.nameTranslations,
        description: data.description,
        descriptionTranslations: data.descriptionTranslations || [],
        destination: data.parent?.id || null,
        knowledgeBaseFilesIds: data.knowledgeBaseFiles?.map((file) => file.id) || [],
        image: data.image?.miniaturePath || null,
        visibility: data.visibility,
        duration: data.duration ? data.duration / 60 : 0,
        labelIds: data.labels?.map(({ id }) => id) || [],
        subForm: {
          difficulty: data.difficulty,
          metadata: metadataRecordToMetadataEntries(data.metadata),
        }
      }
    }
    if (dataType === KnowledgeBaseContentType.QUIZ) {
      return {
        type: KnowledgeBaseContentType.QUIZ,
        name: data.name,
        nameTranslations: data.nameTranslations,
        description: data.description,
        descriptionTranslations: data.descriptionTranslations || [],
        destination: data.parent?.id || null,
        knowledgeBaseFilesIds: data.knowledgeBaseFiles?.map((file) => file.id),
        image: data.image?.miniaturePath || null,
        visibility: data.visibility,
        duration: data.duration && data.duration / 60,
        labelIds: data.labels?.map(({ id }) => id) || [],
        subForm: {
          canGoBack: data.canGoBack || false,
          markWeight: data.markWeight || MIN_MARK_WEIGHT,
          randomQuestionOrder: data.randomQuestionOrder || false,
          showAnswers: data.showAnswers || false,
          quantityOfRandomQuestions: data.quantityOfRandomQuestions || null,
          questions: data.questions,
          quizDuration: !!data.duration,
        }
      }
    }
    if (dataType === KnowledgeBaseContentType.FILE) {
      return {
        type: KnowledgeBaseContentType.FILE,
        name: data.name,
        nameTranslations: data.nameTranslations,
        description: data.description,
        descriptionTranslations: data.descriptionTranslations || [],
        destination: data.parent?.id || null,
        knowledgeBaseFilesIds: data.knowledgeBaseFiles?.map((file) => file.id),
        image: data.image?.miniaturePath || null,
        visibility: data.visibility,
        duration: data.duration && data.duration / 60,
        labelIds: data.labels?.map(({ id }) => id) || [],
        subForm: {}
      }
    }
  }
  return undefined
}

const parseEditContentFields = (
  variables: KnowledgeBaseContentFormFields,
  languageCode: string,
  sendMetadata = true,
): EditKnowledgeBaseObjectVariables['dto'] => {
  const {
    image,
  } = variables

  return {
    ...parseContentFields(variables, languageCode, sendMetadata),
    ...(typeof image !== 'string' && image !== null ? { image } : {}),
  }
}

export { getFormInitValues, parseEditContentFields }
